export default "__VITE_ASSET__BofK20Ta__"